import React from 'react';
import { CheckCircle } from 'lucide-react';
import { GOVERNANCE_ITEMS } from '../config/ztaArchitectureData';

const ZtaGovernanceLayer = ({ getGovernanceState, setEditingGovernance }) => {
  return (
    <section className="zta-layer zta-governance">
      <div className="zta-layer-label">GOVERNANCE</div>
      <div className="zta-governance-items">
        {GOVERNANCE_ITEMS.map((item) => {
          const Icon = item.icon;
          const state = getGovernanceState(item.id);
          const hasData = Object.keys(state).length > 0;

          return (
            <button
              key={item.id}
              className={`zta-gov-item zta-gov-item--${item.type} ${hasData ? 'zta-gov-item--has-data' : ''}`}
              onClick={() => setEditingGovernance(item)}
              title={item.summary}
            >
              <Icon size={14} className="zta-gov-icon" />
              <span className="zta-gov-name">{item.name}</span>
              {hasData && <CheckCircle size={12} className="zta-gov-check" />}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default ZtaGovernanceLayer;
